<template>
  <div>
    <div class="d-flex flex-row flex-wrap justify-content-start mx-3 py-4">
      <div class="w-25 text-left">
        <el-date-picker type="daterange" v-model="selects.date" placeholder="Select Date Picker" range-separator="To"
          start-placeholder="Start date" end-placeholder="End date" @change="getData()"></el-date-picker>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-9">
          <div class="row">
            <div class="col-lg">
              <card style="height: 830px" class="card-eprf">
                <div class="row">
                  <div class="col-lg">
                    <p class="card-title">Waste Disposed</p>
                    <p style="color: #a3a3a3; font-weight: 400">
                      <i>{{ daterange }}</i>
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-10">
                    <div class="chart-area">
                      <line-chart v-if="wastesdisposed.loaded" :chart-data="wastesdisposed.chartData"
                        :extra-options="wastesdisposed.extraOptions" :height="350"></line-chart>
                      <div class="d-flex justify-content-center spinner" v-if="!wastesdisposed.loaded">
                        <circle-8></circle-8>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg">
                    <div class="row" style="padding-top: 8%">
                      <div class="col-lg">
                        <p class="text-eprf">Total Disposal</p>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg text-center">
                        <h1 class="text-primary">
                          {{ totalcollection }}
                        </h1>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg">
                        <p style="color: #a5a5a5">
                          <i class="fa fa-circle" aria-hidden="true" style="color: #358CCB"></i>
                          Waste
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
        <div class="col-lg-3 d-flex">
          <card style="
              margin-left: -15px;
              box-shadow: none;
              padding-top: 30px;
              /* height: 830px; */
              background-color: white;
            ">
            <p style="
                color: #000;
                text-align: center;
                font-size: 20px;
                font-weight: 600;
                padding-bottom: 30px;
              ">
              Top 10 SW Disposed
            </p>
            <div style="height: 80%" class="col-lg-12">
              <div style="padding: 4%" v-for="(file, index) in top5wastes" :key="index" class="row">
                <div class="col-lg-1">
                  <div class="circle">
                    <span class="number">{{ index+1 }}</span>
                  </div>
                </div>
                <div style="color: #A5A5A5" class="col-lg text-center">
                  {{ file.label1 }}
                </div>
                <div style="font-weight: 600; color: #3495c6" class="col-lg-5 text-center">
                  {{ file.total }} MT
                </div>
              </div>
            </div>
            <div style="
                margin-top: 10%;
                width: 108%;
                margin-left: -4%;
                border-top: 1px solid lightgray;
              "></div>
            <div class="row">
              <div style="
                  margin-left: 10px;
                  color: #A5A5A5;
                  padding: 15px;
                  text-align: right;
                " class="col-lg-10">
                See all SW Disposed
              </div>
              <div class="col-lg-1">
                <div class="circle" style="
                    cursor: pointer;
                    margin-left: -15px;
                    margin-top: 10px;
                    padding: 18px;
                  " v-on:click="getJobPage()">
                  <span class="number" style="font-size: 30px; font-weight: 500">&gt;</span>
                </div>
              </div>
              <div class="col-lg"></div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DatePicker } from "element-ui";
import { Circle8 } from "vue-loading-spinner";
import Card from "../../../components/Cards/Card.vue";
import { Modal, ImageUpload } from "../../../../src/components";
import Ongoing from "../../Dashboard/Admin/InventoryList.vue";

import LineChart from "src/components/Charts/LineChart";
import PieChart from "src/components/Charts/PieChart";
import * as chartConfigs from "@/components/Charts/config";

import config from "@/config";
// Import component
import Loading from "vue-loading-overlay";
import moment from "moment";

export default {
  name: "VendorOverview",

  components: {
    Ongoing,
    Card,
    Modal,
    ImageUpload,
    [DatePicker.name]: DatePicker,
    LineChart,
    PieChart,
    Loading,
    Circle8,
  },

  data() {
    return {
      landflag: "total",
      incominglandpie1: "color: #358CCB ",
      incominglandpie2: "color: #000000 ",
      incominglandpie3: "color: #000000 ",
      incominglandpie4: "color: #000000 ",

      total: {},
      completed: {},
      pending: {},
      overdue: {},

      land: [
        { value: "#3495C6", label: "Scheduled Waste" },
        { value: "#33BBB7", label: "Garbage" },
        { value: "#33A02C", label: "Tyre" },
        { value: "#C1C1C1", label: "Scrap" },
        { value: "#EBEBEB", label: "Others" },
      ],

      // Pie Chart
      statusRatio: {
        chartData: {
          labels: ["Scheduled Waste", "Garbage", "Sewage", "Scrap", "Others"],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: [
                "#3495C6",
                "#33BBB7",
                "#33A02C",
                "#C1C1C1",
                "#EBEBEB",
              ],
              borderWidth: 0,
              data: [],
            },
          ],
        },
        loaded: true,
        extraOptions: chartConfigs.pieChartOptions,
      },

      daterange: "Jan - Dec 2023",

      jan: "",
      feb: "",
      mar: "",
      apr: "",
      may: "",
      jun: "",
      jul: "",
      aug: "",
      sep: "",
      oct: "",
      nov: "",
      dec: "",

      totalcollection: 0,
      totaljobcreated: 0,
      totaljobaccepted: 0,
      totaljobcomplete: 0,
      overduejob: 0,

      selects: {
        port: "",
        ports: [],
        date: "",
      },

      top5wastes: [{ name: "sw", total: 5 }],

      wastesdisposed: {
        chartData: {
          labels: [],
          datasets: [
            {
              yAxisID: "a",
              type: "line",
              label: "Sellable",
              fill: false,
              borderColor: "#32BA7C",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.5,
              pointBackgroundColor: "#32BA7C",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#32BA7C",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [5],
            },
          ],
        },
        loaded: false,
        extraOptions: chartConfigs.purpleChartOptionsllll,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 1, 1],
      },
    };
  },
  methods: {
    assignedchart() {
      this.statusRatio.loaded = false;

      if (this.landflag == "total") {
        this.statusRatio = {
          chartData: {
            labels: this.total.label,
            datasets: [
              {
                pointRadius: 0,
                pointHoverRadius: 0,
                backgroundColor: this.total.color,
                borderWidth: 0,
                data: this.total.value,
              },
            ],
          },
          loaded: true,
          extraOptions: {
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: "right",
              labels: {
                usePointStyle: true,
                pointStyle: {
                  margin: "10px",
                },
                boxWidth: 10,
                fontColor: "white",
              },
            },
            elements: {
              center: {
                text: "",
                //   color: "#000000", // Default is #000000
                fontStyle: "Poppins", // Default is Arial
                sidePadding: 20, // Default is 20 (as a percentage)
                minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
                lineHeight: 30, // Default is 25 (in px), used for when text wraps
              },
            },
            responsive: true,
            cutoutPercentage: 80,
            tooltips: {
              backgroundColor: "#f5f5f5",
              titleFontColor: "#333",
              bodyFontColor: "#666",
              bodySpacing: 4,
              xPadding: 12,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
            },
            animation: {
              duration: 100,
              onComplete: function (chart) {
                if (chart.chart.config.options.elements.center) {
                  // Get ctx from string
                  var ctx = chart.chart.ctx;

                  ctx.textAlign = "center";
                  ctx.textBaseline = "middle";
                  var centerX =
                    (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                    2;
                  var centerY =
                    (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                    2;

                  //Draw text in center
                  ctx.font = " 20px Poppins, sans-serif";
                  ctx.fillStyle = "#000000";
                  ctx.fillText("Land", centerX, centerY - 10);
                  ctx.fillText("Generated", centerX, centerY + 15);
                }
              },
            },

            scales: {
              yAxes: [
                {
                  display: 0,
                  ticks: {
                    display: false,
                  },
                  gridLines: {
                    drawBorder: false,
                    zeroLineColor: "transparent",
                    color: "rgba(255,255,255,0.05)",
                  },
                },
              ],

              xAxes: [
                {
                  display: 0,
                  barPercentage: 1.6,
                  gridLines: {
                    drawBorder: false,
                    color: "rgba(255,255,255,0.1)",
                    zeroLineColor: "transparent",
                  },
                  ticks: {
                    display: false,
                  },
                },
              ],
            },
          },
        };
        this.land = [];
        for (var i = 0; i < this.total.label.length; i++) {
          let obj = {
            label: this.total.label[i],
            value: this.total.color[i],
          };
          this.land.push(obj);
        }
      }

      if (this.landflag == "completed") {
        this.statusRatio = {
          chartData: {
            labels: this.completed.label,
            datasets: [
              {
                pointRadius: 0,
                pointHoverRadius: 0,
                backgroundColor: this.completed.color,
                borderWidth: 0,
                data: this.completed.value,
              },
            ],
          },
          loaded: true,
          extraOptions: {
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: "right",
              labels: {
                usePointStyle: true,
                pointStyle: {
                  margin: "10px",
                },
                boxWidth: 10,
                fontColor: "white",
              },
            },
            elements: {
              center: {
                text: "",
                //   color: "#000000", // Default is #000000
                fontStyle: "Poppins", // Default is Arial
                sidePadding: 20, // Default is 20 (as a percentage)
                minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
                lineHeight: 30, // Default is 25 (in px), used for when text wraps
              },
            },
            responsive: true,
            cutoutPercentage: 80,
            tooltips: {
              backgroundColor: "#f5f5f5",
              titleFontColor: "#333",
              bodyFontColor: "#666",
              bodySpacing: 4,
              xPadding: 12,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
            },
            animation: {
              duration: 500,
              onComplete: function (chart) {
                if (chart.chart.config.options.elements.center) {
                  // Get ctx from string
                  var ctx = chart.chart.ctx;

                  ctx.textAlign = "center";
                  ctx.textBaseline = "middle";
                  var centerX =
                    (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                    2;
                  var centerY =
                    (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                    2;

                  //Draw text in center
                  ctx.font = " 20px Poppins, sans-serif";
                  ctx.fillStyle = "#000000";
                  ctx.fillText("Land", centerX, centerY - 10);
                  ctx.fillText("Generated", centerX, centerY + 15);
                }
              },
            },

            scales: {
              yAxes: [
                {
                  display: 0,
                  ticks: {
                    display: false,
                  },
                  gridLines: {
                    drawBorder: false,
                    zeroLineColor: "transparent",
                    color: "rgba(255,255,255,0.05)",
                  },
                },
              ],

              xAxes: [
                {
                  display: 0,
                  barPercentage: 1.6,
                  gridLines: {
                    drawBorder: false,
                    color: "rgba(255,255,255,0.1)",
                    zeroLineColor: "transparent",
                  },
                  ticks: {
                    display: false,
                  },
                },
              ],
            },
          },
        };
        this.land = [];
        for (var i = 0; i < this.completed.label.length; i++) {
          let obj = {
            label: this.completed.label[i],
            value: this.completed.color[i],
          };
          this.land.push(obj);
        }
      }

      if (this.landflag == "pending") {
        this.statusRatio = {
          chartData: {
            labels: this.pending.label,
            datasets: [
              {
                pointRadius: 0,
                pointHoverRadius: 0,
                backgroundColor: this.pending.color,
                borderWidth: 0,
                data: this.pending.value,
              },
            ],
          },
          loaded: true,
          extraOptions: {
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: "right",
              labels: {
                usePointStyle: true,
                pointStyle: {
                  margin: "10px",
                },
                boxWidth: 10,
                fontColor: "white",
              },
            },
            elements: {
              center: {
                text: "",
                //   color: "#000000", // Default is #000000
                fontStyle: "Poppins", // Default is Arial
                sidePadding: 20, // Default is 20 (as a percentage)
                minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
                lineHeight: 30, // Default is 25 (in px), used for when text wraps
              },
            },
            responsive: true,
            cutoutPercentage: 80,
            tooltips: {
              backgroundColor: "#f5f5f5",
              titleFontColor: "#333",
              bodyFontColor: "#666",
              bodySpacing: 4,
              xPadding: 12,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
            },
            animation: {
              duration: 500,
              onComplete: function (chart) {
                if (chart.chart.config.options.elements.center) {
                  // Get ctx from string
                  var ctx = chart.chart.ctx;

                  ctx.textAlign = "center";
                  ctx.textBaseline = "middle";
                  var centerX =
                    (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                    2;
                  var centerY =
                    (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                    2;

                  //Draw text in center
                  ctx.font = " 20px Poppins, sans-serif";
                  ctx.fillStyle = "#000000";
                  ctx.fillText("Land", centerX, centerY - 10);
                  ctx.fillText("Generated", centerX, centerY + 15);
                }
              },
            },

            scales: {
              yAxes: [
                {
                  display: 0,
                  ticks: {
                    display: false,
                  },
                  gridLines: {
                    drawBorder: false,
                    zeroLineColor: "transparent",
                    color: "rgba(255,255,255,0.05)",
                  },
                },
              ],

              xAxes: [
                {
                  display: 0,
                  barPercentage: 1.6,
                  gridLines: {
                    drawBorder: false,
                    color: "rgba(255,255,255,0.1)",
                    zeroLineColor: "transparent",
                  },
                  ticks: {
                    display: false,
                  },
                },
              ],
            },
          },
        };

        this.land = [];
        for (var i = 0; i < this.pending.label.length; i++) {
          let obj = {
            label: this.pending.label[i],
            value: this.pending.color[i],
          };
          this.land.push(obj);
        }
      }

      if (this.landflag == "overdue") {
        this.statusRatio = {
          chartData: {
            labels: this.overdue.label,
            datasets: [
              {
                pointRadius: 0,
                pointHoverRadius: 0,
                backgroundColor: this.overdue.color,
                borderWidth: 0,
                data: this.overdue.value,
              },
            ],
          },
          loaded: true,
          extraOptions: {
            maintainAspectRatio: false,
            legend: {
              display: false,
              position: "right",
              labels: {
                usePointStyle: true,
                pointStyle: {
                  margin: "10px",
                },
                boxWidth: 10,
                fontColor: "white",
              },
            },
            elements: {
              center: {
                text: "",
                //   color: "#000000", // Default is #000000
                fontStyle: "Poppins", // Default is Arial
                sidePadding: 20, // Default is 20 (as a percentage)
                minFontSize: 20, // Default is 20 (in px), set to false and text will not wrap.
                lineHeight: 30, // Default is 25 (in px), used for when text wraps
              },
            },
            responsive: true,
            cutoutPercentage: 80,
            tooltips: {
              backgroundColor: "#f5f5f5",
              titleFontColor: "#333",
              bodyFontColor: "#666",
              bodySpacing: 4,
              xPadding: 12,
              mode: "nearest",
              intersect: 0,
              position: "nearest",
            },
            animation: {
              duration: 500,
              onComplete: function (chart) {
                if (chart.chart.config.options.elements.center) {
                  // Get ctx from string
                  var ctx = chart.chart.ctx;

                  ctx.textAlign = "center";
                  ctx.textBaseline = "middle";
                  var centerX =
                    (chart.chart.chartArea.left + chart.chart.chartArea.right) /
                    2;
                  var centerY =
                    (chart.chart.chartArea.top + chart.chart.chartArea.bottom) /
                    2;

                  //Draw text in center
                  ctx.font = " 20px Poppins, sans-serif";
                  ctx.fillStyle = "#000000";
                  ctx.fillText("Land", centerX, centerY - 10);
                  ctx.fillText("Generated", centerX, centerY + 15);
                }
              },
            },

            scales: {
              yAxes: [
                {
                  display: 0,
                  ticks: {
                    display: false,
                  },
                  gridLines: {
                    drawBorder: false,
                    zeroLineColor: "transparent",
                    color: "rgba(255,255,255,0.05)",
                  },
                },
              ],

              xAxes: [
                {
                  display: 0,
                  barPercentage: 1.6,
                  gridLines: {
                    drawBorder: false,
                    color: "rgba(255,255,255,0.1)",
                    zeroLineColor: "transparent",
                  },
                  ticks: {
                    display: false,
                  },
                },
              ],
            },
          },
        };

        this.land = [];
        for (var i = 0; i < this.overdue.label.length; i++) {
          let obj = {
            label: this.overdue.label[i],
            value: this.overdue.color[i],
          };
          this.land.push(obj);
        }
      }
    },
    generateland(flag) {
      this.landflag = flag;
      if (flag == "total") {
        this.incominglandpie1 = "color: #358CCB !important;";
        this.incominglandpie2 = "color: #000000";
        this.incominglandpie3 = "color: #000000";
        this.incominglandpie4 = "color: #000000";
      }

      if (flag == "completed") {
        this.incominglandpie1 = "color: #000000  ";
        this.incominglandpie2 = "color: #358CCB !important;";
        this.incominglandpie3 = "color: #000000";
        this.incominglandpie4 = "color: #000000";
      }

      if (flag == "pending") {
        this.incominglandpie1 = "color: #000000  ";
        this.incominglandpie2 = "color: #000000";
        this.incominglandpie3 = "color: #358CCB !important;";
        this.incominglandpie4 = "color: #000000";
      }

      if (flag == "overdue") {
        this.incominglandpie1 = "color: #000000  ";
        this.incominglandpie2 = "color: #000000";
        this.incominglandpie3 = "color: #000000";
        this.incominglandpie4 = "color: #358CCB !important;";
      }

      this.assignedchart();
    },
    getJobPage() {
      this.$router.push("/Vendor/Job");
    },
    getData() {
      this.wastesdisposed.loaded = false
      let start = moment(this.selects.date[0]).format("YYYY-MM-DD");
      let end = moment(this.selects.date[1]).format("YYYY-MM-DD");

      this.$http
        .get(
          ":10001/api/v1/overview/outgoing?start_date=" +
          start +
          "&end_date=" +
          end
          // +
          // "&service_location"
          //  +
          // this.selects.port
        )
        .then((res) => {
          let response = res.message;
          // this.wastesdisposed.loaded = false;

          this.totaljobcreated = response.job_status.created;
          this.totaljobaccepted = response.job_status.accepted;
          this.totaljobcomplete = response.job_status.completed;
          this.overduejob = response.job_status.pending;

          let timestamp = [];
          let data1 = [];
          let data2 = [];
          for (var i = 0; i < response.graph.label_month.length; i++) {
            timestamp.push(response.graph.label_month[i]);
            data1.push(response.graph.quantity[i]);
            this.totalcollection += parseFloat(response.graph.quantity[i])
          }

          this.wastesdisposed = {
            chartData: {
              labels: timestamp,
              datasets: [
                {
                  yAxisID: "y-axis-1",
                  type: "line",
                  label: "Waste",
                  fill: false,
                  borderColor: "#358CCB",
                  borderWidth: 2,
                  borderDash: [],
                  borderDashOffset: 0.5,
                  pointBackgroundColor: "#358CCB",
                  pointBorderColor: "rgba(255,255,255,0)",
                  pointHoverBackgroundColor: "#358CCB",
                  pointBorderWidth: 20,
                  pointHoverRadius: 4,
                  pointHoverBorderWidth: 15,
                  pointRadius: 4,
                  data: data1,
                },
              ],
            },
            loaded: true,
            extraOptions: chartConfigs.purpleChartOptionslll,
            gradientColors: config.colors.primaryGradient,
            gradientStops: [1, 1, 1],
          };

          this.top5wastes = [];
          if (response.top_outgoing != null)
            for (var i = 0; i < response.top_outgoing.length; i++) {
              if (i === 10) {
                break
              }
              let obj = {
                name: response.top_outgoing[i].name,
                total: response.top_outgoing[i].quantity,
              };
              this.top5wastes.push(obj);
            }
        });
    },
  },
  created() {
    this.selects.date = [moment().startOf("y"), moment().endOf("y")];

    this.getData();

  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  watch: {
    "selects.date"() {
      this.daterange =
        moment(this.selects.date[0]).format("MMM") +
        " - " +
        moment(this.selects.date[1]).format("MMM YYYY");

      // this.getlandpiedata();
    },
  },
};
</script>
<style scoped>
.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.legend-circle {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 8px;
}

.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.custom-input {
  padding: 5px 10px 5px 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}

p {
  margin-top: 10px;
  font-size: 14px;
  color: #333;
}

.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}

.circle {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #3495c6;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
}

.number {
  color: white;
}

.pie-chart-container {
  position: relative;
  width: 100%;
  /* Set width as required */
  height: 250px;
  /* Set height as required */
}

.chart-title {
  width: 100px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  /* Other styling properties as needed */
}

.label {
  color: #666;
}

.label2 {
  color: #ccc;
  margin-top: -7px;
  font-size: 12px;
}
</style>
